export default class Param {
    constructor(){

        this.breakpoint = 750;
        this.displayType = ( window.innerWidth>this.breakpoint)?"pc":"sp";


        this.webgl = {
            mainvisual : {
                shader : {
                    vert : require('../shader/mainvisual.vert'),
                    frag : require('../shader/mainvisual.frag')
                }
            },
            panel : {
                shader : {
                    vert : require('../shader/gradient.vert'),
                    frag : require('../shader/gradient.frag')
                }
            },
        }

        this.status = {

        }


    }
}
